export function toggleGrabbing(isGrabbing) {
  isGrabbing ?
    document.body.classList.add('grabbing')
  : document.body.classList.remove('grabbing');
}
